"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TestVideoLink = function TestVideoLink(_ref) {
  var className = _ref.className,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Test Your Video Connection' : _ref$text;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)(className, 'primary-link test-call-link'),
    href: "https://tokbox.com/developer/tools/precall/",
    rel: "noopener noreferrer",
    target: "_blank"
  }, text);
};
var _default = TestVideoLink;
exports.default = _default;